import { atom } from "jotai";
import { File } from "@/entities/FileService/File.model";

export const selectedUploadAtom = atom<File | null>(null);
export const showUploadFormAtom = atom<boolean>(false);
